import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "../../zisComponents/grid/Grid.scss";
import "./VytvoritVyjadrenie.scss";

// cora web components
import Button from "../../coraWebComponents/buttons/Button";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import { buildUrl } from "../../coraWebComponents/utils/helper";
import { dateToDateStr } from "../../coraWebComponents/utils/convert";
import withRouter from "../../coraWebComponents/utils/withRouter";
import fileSaver from "file-saver";

// proptypes
import ziadostPropTypes from "../../propTypes/ziadostPropTypes";

// actions
import * as filesActions from "../../actions/filesActions";
import * as vyjadrenieActions from "../../actions/vyjadrenieActions";

class Rekapitulacia extends React.Component {
  downloadFile = (file, fileName) => {
    fileSaver.saveAs(file, fileName);
  };
  renderOsobaData = (data) => {
    const { Adresa, Kontakt, OsobneUdaje } = data;

    const { I_O_TYP, MENO, PRIEZVISKO, ICO, NAZOV } = OsobneUdaje;
    const { ADRESA_MERGED } = Adresa;
    const { EMAIL, TELEFON } = Kontakt;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">
            {I_O_TYP === 1 ? "Meno a priezvisko:" : "Názov a IČO:"}
          </div>
          <div className="col-6 p-0 gridDetailCol">
            {I_O_TYP === 1 ? `${MENO} ${PRIEZVISKO}` : `${NAZOV} ${ICO}`}
          </div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Adresa:"}</div>
          <div className="col-6 p-0 gridDetailCol">{ADRESA_MERGED}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Telefón:"}</div>
          <div className="col-6 p-0 gridDetailCol">{TELEFON}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Email:"}</div>
          <div className="col-6 p-0 gridDetailCol">{EMAIL}</div>
        </div>
      </>
    );
  };
  renderDovodPrioritaData = (dovod, priorita) => {
    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Druh:"}</div>
          <div className="col-6 p-0 gridDetailCol">{dovod.N_DOVOD}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Priorita:"}</div>
          <div className="col-6 p-0 gridDetailCol">{priorita.N_PRIORITA}</div>
        </div>
      </>
    );
  };
  renderDetailStavbyData = (data) => {
    const { N_TYP_PRACE, NAZOV_PROJEKTU } = data;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Typ práce:"}</div>
          <div className="col-6 p-0 gridDetailCol">{N_TYP_PRACE}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Názov projektu / Názov stavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{NAZOV_PROJEKTU}</div>
        </div>
      </>
    );
  };
  renderAdresaStavbyData = (ADRESA_STAVBA) => {
    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Adresa:"}</div>
          <div className="col-6 p-0 gridDetailCol">{ADRESA_STAVBA}</div>
        </div>
      </>
    );
  };
  renderStaveniskoData = (data) => {
    const { STAVENISKO_NAZOV, STAVENISKO_KONTAKT, STAVENISKO_VEDUCI } = data;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Názov spoločnosti:"}</div>
          <div className="col-6 p-0 gridDetailCol">{STAVENISKO_NAZOV}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Vedúci stavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{STAVENISKO_VEDUCI}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Kontakt:"}</div>
          <div className="col-6 p-0 gridDetailCol">{STAVENISKO_KONTAKT}</div>
        </div>
      </>
    );
  };
  renderDoleziteData = (data) => {
    const { D_POZADOVANE_VYBAVENIE, D_ZAC_STAVBY, D_UKONC_STAVBY, CIS_ZIAD_ISV, ID_STAV_ISV } = data;
    const isAnyDateSet = D_POZADOVANE_VYBAVENIE || D_ZAC_STAVBY || D_UKONC_STAVBY;
    return (
      <>
        {isAnyDateSet && (
          <div className="row m-0">
            <div className="col-6 p-0 gridDetailCol">{"Požadovaný dátum vybavenia:"}</div>
            <div className="col-6 p-0 gridDetailCol">{dateToDateStr(D_POZADOVANE_VYBAVENIE)}</div>
          </div>
        )}
        {isAnyDateSet && (
          <div className="row m-0">
            <div className="col-6 p-0 gridDetailCol">{"Dátum zač. stavby:"}</div>
            <div className="col-6 p-0 gridDetailCol">{dateToDateStr(D_ZAC_STAVBY)}</div>
          </div>
        )}
        {isAnyDateSet && (
          <div className="row m-0">
            <div className="col-6 p-0 gridDetailCol">{"Dátum ukon. stavby:"}</div>
            <div className="col-6 p-0 gridDetailCol">{dateToDateStr(D_UKONC_STAVBY)}</div>
          </div>
        )}
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Číslo žiadosti z IS výstavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{CIS_ZIAD_ISV}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"ID stavby z IS výstavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{ID_STAV_ISV}</div>
        </div>
      </>
    );
  };
  renderPrilohyKomentareData = (data) => {
    const { KOMENTAR, Prilohy } = data;
    const { downloadPriloha } = this.props;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Komentár:"}</div>
          <div className="col-6 p-0 gridDetailCol">{KOMENTAR}</div>
        </div>
        {Prilohy.map((priloha, key) => {
          const { FILE_NAME, I_AG_ZIAD_BIN } = priloha;
          return (
            <div key={key} className="row m-0 download-label-button-container">
              <div className="col-6 p-0 gridDetailCol">{FILE_NAME}</div>
              <div className="col-6 p-0 gridDetailCol download-button">
                <Button
                  imageUrl={buildUrl("assets/notify_stiahnut.svg")}
                  onClick={async () =>
                    await downloadPriloha(I_AG_ZIAD_BIN, FILE_NAME, false)
                  }
                />
              </div>
            </div>
          );
        })}
      </>
    );
  };
  renderOblastZaujmuData = (data) => {
    const { MapImage, AdresaStavby } = data;
    return (
      <>
        <div className="row m-0">
          <div className="col-2 p-0 gridDetailCol">{"Adresa:"}</div>
          <div className="col-10 p-0 gridDetailCol">
            {AdresaStavby.ADRESA_MERGED}
          </div>
        </div>
        <div className="row m-0">
          <div className="col-12 p-0 gridDetailCol imageContainer">
            {MapImage && (
              <img
                className="imageMap"
                src={`${"data:image/png;base64," + MapImage}`}
                alt="ThumnailPhoto"
              ></img>
            )}
          </div>
        </div>
      </>
    );
  };
  renderVyjadrenie = (data) => {
    const { N_VYSLEDOK, komentar } = data;

    return (
      <>
        <div className="row m-0">
          <div className="col-4 p-0 gridDetailCol">
            {"Výsledok vyjadrenia:"}
          </div>
          <div className="col-8 p-0 gridDetailCol">{N_VYSLEDOK}</div>
        </div>
        <div className="row m-0">
          <div className="col-2 p-0 gridDetailCol">{"Komentár:"}</div>
          <div className="col-10 p-0 gridDetailCol">{komentar}</div>
        </div>
      </>
    );
  };
  renderDokumenty = (data) => {
    const { reportsNames, filesNames, prilohy } = data;
    const { downloadReportInPDF, ziadost } = this.props;

    return (
      <>
        {[...reportsNames].filter(x => x.L_CHECK).map((x, i) => {
          return (
            <div key={i} className="row m-0 download-label-button-container">
              <div className="col-6 p-0 gridDetailCol">
                {x.NAME.replace(".docx", ".pdf")}
              </div>
              <div className="col-6 p-0 gridDetailCol download-button">
                <Button
                  imageUrl={buildUrl("assets/notify_stiahnut.svg")}
                  onClick={async () =>
                    await downloadReportInPDF(x.NAME, ziadost.I_AG_ZIADOST)
                  }
                />
              </div>
            </div>
          );
        })}
        {[...filesNames].map((fName, i) => {
          return (
            <div
              key={i + reportsNames.length}
              className="row m-0 download-label-button-container"
            >
              <div className="col-6 p-0 gridDetailCol">{fName}</div>
              <div className="col-6 p-0 gridDetailCol download-button">
                <Button
                  imageUrl={buildUrl("assets/notify_stiahnut.svg")}
                  onClick={() => this.downloadFile(prilohy[i], fName)}
                />
              </div>
            </div>
          );
        })}
      </>
    );
  };
  handleOnClick = async (e) => {
    const { ulozitVyjadrenie, vyjadrenie, cancel, ziadost } = this.props;

    const { I_AG_ZIADOST } = ziadost;
    const { I_VYSLEDOK, komentar } = vyjadrenie.vyjadrenie;
    const { filesNames, prilohy, reportsNames } = vyjadrenie.dokumenty;
    const data = { I_AG_ZIADOST, I_VYSLEDOK, komentar };

    await ulozitVyjadrenie(data, filesNames, prilohy, reportsNames.filter(x => x.L_CHECK).map(x => x.NAME));
    cancel();
  };
  render() {
    const { className, cancel, moveBack, vyjadrenie, ziadost, isLoading } = this.props;

    return (
      <div className={`row m-0 ${className}`}>
        <div className="col p-0 forWeb">
          <div className="card formular">
            <div className="form-body">
              <div className="card-title">
                <div>Rekapitulácia vyjadrenia k žiadosti {ziadost.KOD_ZIADOSTI}</div>
              </div>
              {ziadost?.InfoZiadatel && ziadost.DetailStavby && (
                <>
                  {/* ZIADATEL/VLASTNIK - HLAVICKA*/}
                  <div className="row m-0">
                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Žiadateľ:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />

                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Vlastník:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />
                  </div>
                  {/* ZIADATEL/VLASTNIK - DATA*/}
                  <div className="row m-0">
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderOsobaData(ziadost.InfoZiadatel.Ziadatel)}
                    </div>
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderOsobaData(ziadost.InfoZiadatel.Vlastnik)}
                    </div>
                  </div>

                  {/* SEPARATOR */}
                  <div className="row m-0 ziadostDetailSeparator" />

                  {/* DOVOD ZIADOSTI/DETAIL STAVBY - HLAVICKA*/}
                  <div className="row m-0">
                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Druh žiadosti:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />

                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Detail stavby:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />
                  </div>
                  {/* DOVOD ZIADOSTI/DETAIL STAVBY - DATA*/}
                  <div className="row m-0">
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderDovodPrioritaData(ziadost.Dovod, ziadost.Priorita)}
                    </div>
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderDetailStavbyData(ziadost.DetailStavby)}
                    </div>
                  </div>

                  {/* SEPARATOR */}
                  <div className="row m-0 ziadostDetailSeparator" />

                  {/* ADRESA STAVBY/STAVENISKO - HLAVICKA*/}
                  <div className="row m-0">
                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Adresa stavby:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />

                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Stavenisko:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />
                  </div>
                  {/* ADRESA STAVBY/STAVENISKO - DATA*/}
                  <div className="row m-0">
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderAdresaStavbyData(ziadost.ADRESA_STAVBA)}
                    </div>
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderStaveniskoData(ziadost.DetailStavby)}
                    </div>
                  </div>

                  {/* SEPARATOR */}
                  <div className="row m-0 ziadostDetailSeparator" />

                  {/* DOLEZITE DATA/PRILOHY A KOMENTARE - HLAVICKA */}
                  <div className="row m-0">
                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Dôležité dáta:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />

                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Prílohy a komentáre:</strong>
                    </div>
                    <div className="col-3 p-0 gridDetailCol" />
                  </div>
                  {/* DOLEZITE DATA/PRILOHY A KOMENTARE - DATA */}
                  <div className="row m-0">
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderDoleziteData(ziadost.DetailStavby)}
                    </div>
                    <div className="col-6 p-0 gridDetailCol">
                      {this.renderPrilohyKomentareData(ziadost.PrilohyKomentar)}
                    </div>
                  </div>

                  {vyjadrenie?.vyjadrenie && vyjadrenie.dokumenty && (
                    <>
                      {/* SEPARATOR */}
                      <div className="row m-0 ziadostDetailSeparator" />

                      {/* VYJADRENIE - HLAVICKA */}
                      <div className="row m-0">
                        <div className="col-3 p-0 gridDetailCol">
                          <strong>Vyjadrenie:</strong>
                        </div>
                        <div className="col-3 p-0 gridDetailCol"></div>
                        <div className="col-3 p-0 gridDetailCol">
                          <strong>Dokumenty:</strong>
                        </div>
                        <div className="col-3 p-0 gridDetailCol"></div>
                      </div>
                      {/* VYJADRENIE - DATA */}
                      <div className="row m-0">
                        <div className="col-6 p-0 gridDetailCol">
                          {this.renderVyjadrenie(vyjadrenie.vyjadrenie)}
                        </div>
                        <div className="col-6 p-0 gridDetailCol">
                          {this.renderDokumenty(vyjadrenie.dokumenty)}
                        </div>
                      </div>
                    </>
                  )}

                  {/* SEPARATOR */}
                  <div className="row m-0 ziadostDetailSeparator" />

                  {/* OBLAST ZAUJMU - HLAVICKA */}
                  <div className="row m-0">
                    <div className="col-3 p-0 gridDetailCol">
                      <strong>Oblasť záujmu:</strong>
                    </div>
                    <div className="col-9 p-0 gridDetailCol" />
                  </div>
                  {/* OBLAST ZAUJMU - DATA */}
                  <div className="row m-0">
                    <div className="col-12 p-0 gridDetailCol">
                      {this.renderOblastZaujmuData(ziadost.OblastZaujmu)}
                    </div>
                  </div>
                </>
              )}
              {/* BUTTONS */}
              <div className="k-form-field flexGroup">
                <Button primary label="Zrusiť" onClick={cancel} />
                <div className="flexGroup">
                  <Button primary label="Späť" onClick={moveBack} />
                  <Button label="Uložiť" onClick={this.handleOnClick} primary />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col p-0 forMobile">
          <div className="card formular">
            <div className="form-body">
              <div className="card-title">
                <div>Rekapitulácia</div>
              </div>
              {/* BUTTONS */}
              <div className="k-form-field flexGroup">
                <Button primary label="Zrusiť" onClick={cancel} />
                <div className="flexGroup">
                  <Button primary label="Späť" onClick={moveBack} />
                  <Button label="Uložiť" onClick={this.handleOnClick} primary />
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ziadost: state.ziadost.data,
    vyjadrenie: state.vyjadrenie.data,
    isLoading: state.files.isLoading || state.vyjadrenie.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  downloadReportInPDF: (reportName, I_AG_ZIADOST) =>
    dispatch(filesActions.downloadReport(reportName, I_AG_ZIADOST, true)),
  downloadPriloha: (I_AG_ZIAD_BIN, FILE_NAME, L_VYJADRENIE) =>
    dispatch(filesActions.downloadPriloha(I_AG_ZIAD_BIN, FILE_NAME, L_VYJADRENIE)),
  ulozitVyjadrenie: (vyjadrenie, filesNames, files, reportsNames) =>
    dispatch(
      vyjadrenieActions.ulozitVyjadrenie(
        vyjadrenie,
        filesNames,
        files,
        reportsNames
      )
    ),
});

Rekapitulacia.propTypes = {
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  ziadost: ziadostPropTypes.ziadost,
  vyjadrenie: PropTypes.object.isRequired,
  downloadReportInPDF: PropTypes.func,
  downloadPriloha: PropTypes.func,
  ulozitVyjadrenie: PropTypes.func,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Rekapitulacia)
);
